import { NoticeProps } from './Notice';
import theme from '../../../lib/theme';

const {
  colors,
  font: {
    families,
    spacings,
    heights,

    ...font
  },
} = theme;

export default ({
  brand = 'sas',
  color = 'black',
  align = 'justify',
}: NoticeProps) => ({
  container: {
    color: colors[brand][color] || colors[color],
    textAlign: align,
    fontFamily: families.primary,
    fontWeight: font.normal,
    fontSize: font.xs,
    lineHeight: heights.xs,

    '& > a': {
      textDecoration: 'underline !important',
    },
  },
});
